var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sca-simple-editor" },
    [
      _c("editor-menu-bar", {
        attrs: { editor: _vm.editor },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var commands = ref.commands
              var isActive = ref.isActive
              return [
                _c("div", { staticClass: "menu" }, [
                  _c(
                    "div",
                    {
                      class: [{ "is-active": isActive.bold() }, "menu-option"],
                      on: { click: commands.bold }
                    },
                    [_c("b-icon-type-bold")],
                    1
                  ),
                  _c(
                    "div",
                    {
                      class: [
                        { "is-active": isActive.italic() },
                        "menu-option"
                      ],
                      on: { click: commands.italic }
                    },
                    [_c("b-icon-type-italic")],
                    1
                  ),
                  _c(
                    "div",
                    {
                      class: [
                        { "is-active": isActive.underline() },
                        "menu-option"
                      ],
                      on: { click: commands.underline }
                    },
                    [_c("b-icon-type-underline")],
                    1
                  ),
                  _c(
                    "div",
                    {
                      class: [
                        { "is-active": isActive.strike() },
                        "menu-option"
                      ],
                      on: { click: commands.strike }
                    },
                    [_c("b-icon-type-strikethrough")],
                    1
                  ),
                  _c("div", { staticClass: "hidden flex-row gap-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "rotate-45",
                        on: { click: commands.undo }
                      },
                      [_c("b-icon-arrow-90deg-left")],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "rotate-45",
                        on: { click: commands.redo }
                      },
                      [_c("b-icon-arrow-90deg-right")],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    {
                      class: [
                        { "is-active": isActive.bullet_list() },
                        "menu-option"
                      ],
                      on: { click: commands.bullet_list }
                    },
                    [_c("b-icon-list-ul")],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c("editor-content", {
        staticClass: "simple-editor simple-content",
        attrs: { value: _vm.value, editor: _vm.editor }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }